<template>
    <b-navbar id="nav-header" toggleable="lg" type="light" variant="white" class="">

        <b-navbar-brand :href="publicWebURI" class="d-flex">
            <img src="../assets/ClaveVerde - Full logo.webp" alt="Clave Verde" height="30"
                class="logo d-inline-block align-top" />
        </b-navbar-brand>

        <template v-if="displayTopLinks">
            <b-navbar-toggle target="nav-collapse">
                <i class="fa fa-bars fa-fw"></i>
            </b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav v-model="isNavCollapsed">
                <b-navbar-nav class="ml-auto">
                    
                    <b-nav-item :to="{name: 'Home'}">Inicio</b-nav-item>

                    <b-nav-item :to="{name: 'Compatibility'}">Compatibilidad</b-nav-item>

                    <b-nav-item :to="{name: 'Portability'}">Portabilidad</b-nav-item>

                    <b-nav-item :to="{name: 'About'}">Acerca de</b-nav-item>
                        
                    <template v-if="isLogged">
                        <b-nav-item :to="{name: 'MyAccount'}">
                            <i class="fa fa-user-circle"></i>
                            Mi cuenta
                        </b-nav-item>
                        <b-nav-item class="warning" @click="$store.dispatch('authTryLogout')">
                            <i class="fa fa-sign-out"></i> Salir
                        </b-nav-item>
                    </template>

                    <b-nav-item v-else @click="$refs.accessFormFromLogin.showModalLogin()">
                        <i class="fa fa-sign-in"></i>
                        Acceder
                    </b-nav-item>

                    <!-- <b-nav-item @click="$refs.accessFormFromLogin.showModalRegister()"> -->
                        <!-- <i class="fa fa-sign-in"></i> -->
                        <!-- Crear cuenta -->
                    <!-- </b-nav-item> -->

                </b-navbar-nav>
            </b-collapse>

        </template>
        <access-form ref="accessFormFromLogin" id="accessFormFromLogin" show-tabs />
    </b-navbar>
</template>

<script>
import { publicWebURI } from '@/apiConfig'
import { mapGetters } from 'vuex/dist/vuex.common.js';
export default {
    name: "navHeader",
    props: {
        displayTopLinks: {
            type: Boolean,
            default: true
        },
        publicWebURI: {
            type: String,
            default: () => publicWebURI
        }
    },
    computed: {
        ...mapGetters(['isLogged'])
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            // Collapse the navbar on window resize
            if (this.$root.$emit && this.isNavCollapsed) {
                this.$root.$emit('bv::toggle::collapse', 'nav-collapse');
            }
        }
    },
    data: () => {
        return {
            isNavCollapsed: false
        };
    }
};
</script>

<style lang="scss">
@import '@/scss/app.scss';

#nav-header {
    $margin: 1.0em;
    padding: 1.25rem;

    text-transform: uppercase;
    font-weight: bold;

    background-color: rgba(255, 255, 255, 0.7) !important;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);

    .logo {
        transform: scale(2.25) translateY(0.0em);
        margin-left: $margin;
        margin-right: $margin;
    }

    .navbar-nav {
        display: flex;
        flex-flow: row;
        gap: 0.5em;

        @media (max-width: 991px) {
            margin-top: 2rem;
            flex-flow: column;
        }

        .nav-item {
            .nav-link {
                padding: 0.5em 1.5em;
                border-radius: 30px;
                background-color: $body-bg;
                transition: background-color 0.5s ease-out;
                
                &:hover:not(.router-link-active) {
                    transition: background-color 0.15s ease-in;
                    background-color: $primary;
                    color: white;
                }
                
                &.router-link-active:hover {
                    // background-color: $primary-light;
                    // color: white;
                }
                
                &.router-link-active{
                    // background-color: $primary;
                    color: $primary;
                    
                }
            }
            &.warning {
                .nav-link {
                    padding: 0.5em 0.75em;
                    &:hover{
                        background-color: $warning;
                    }
                }
            }
        }
    }
}
</style>

